import { useState, useEffect } from 'react'

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export const useAudioPlayer = (ref?: React.RefObject<HTMLAudioElement>) => {
  const [duration, setDuration] = useState(0)
  const [curTime, setCurTime] = useState(0)
  const [playing, setPlaying] = useState(false)
  const [clickedTime, setClickedTime] = useState(0)
  const [rate, setRate] = useState(1.0)
  const [src, setSrc] = useState(null)

  useEffect(() => {
    if (!ref?.current) return
    const audio = ref.current
    const setAudioTime = () => {
      setCurTime(audio.currentTime)
    }

    // loadeddataやloadedmetadataはなぜかNext.jsでは発火しないため、audioのpropsでonLoadedMetadataなど指定する
    audio.addEventListener('timeupdate', setAudioTime)
    return () => {
      audio.removeEventListener('timeupdate', setAudioTime)
    }
  }, [duration])

  useEffect(() => {
    if (!ref?.current) return
    const audio = ref?.current
    if (src) {
      audio.src = src
    }
    playing ? audio.play() : audio.pause()
    audio.playbackRate = rate

    // スライダーをドラッグまたはクリックしたとき
    if (clickedTime && clickedTime !== curTime) {
      audio.currentTime = clickedTime
      setClickedTime(null)
    }
  }, [clickedTime, playing, rate, src])
  return {
    curTime,
    setCurTime,
    duration,
    playing,
    setPlaying,
    setClickedTime,
    setDuration,
    setRate,
    setSrc,
  }
}
